export const LIST_MCU_PROJECT_PATIENT_REQUEST = 'LIST_MCU_PROJECT_PATIENT_REQUEST'
export const LIST_MCU_PROJECT_PATIENT_SUCCESS = 'LIST_MCU_PROJECT_PATIENT_SUCCESS'
export const LIST_MCU_PROJECT_PATIENT_FAIL = 'LIST_MCU_PROJECT_PATIENT_FAIL'

export const LIST_MCU_PROJECT_PATIENT_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_PATIENT_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_PATIENT_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_PATIENT_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_PATIENT_SUMMARY_FAIL = 'LIST_MCU_PROJECT_PATIENT_SUMMARY_FAIL'

export const CREATE_MCU_PROJECT_PATIENT_REQUEST = 'CREATE_MCU_PROJECT_PATIENT_REQUEST'
export const CREATE_MCU_PROJECT_PATIENT_SUCCESS = 'CREATE_MCU_PROJECT_PATIENT_SUCCESS'
export const CREATE_MCU_PROJECT_PATIENT_FAIL = 'CREATE_MCU_PROJECT_PATIENT_FAIL'

export const DETAIL_MCU_PROJECT_PATIENT_REQUEST = 'DETAIL_MCU_PROJECT_PATIENT_REQUEST'
export const DETAIL_MCU_PROJECT_PATIENT_SUCCESS = 'DETAIL_MCU_PROJECT_PATIENT_SUCCESS'
export const DETAIL_MCU_PROJECT_PATIENT_FAIL = 'DETAIL_MCU_PROJECT_PATIENT_FAIL'

export const UPDATE_MCU_PROJECT_PATIENT_REQUEST = 'UPDATE_MCU_PROJECT_PATIENT_REQUEST'
export const UPDATE_MCU_PROJECT_PATIENT_SUCCESS = 'UPDATE_MCU_PROJECT_PATIENT_SUCCESS'
export const UPDATE_MCU_PROJECT_PATIENT_FAIL = 'UPDATE_MCU_PROJECT_PATIENT_FAIL'

export const DELETE_MCU_PROJECT_PATIENT_REQUEST = 'DELETE_MCU_PROJECT_PATIENT_REQUEST'
export const DELETE_MCU_PROJECT_PATIENT_SUCCESS = 'DELETE_MCU_PROJECT_PATIENT_SUCCESS'
export const DELETE_MCU_PROJECT_PATIENT_FAIL = 'DELETE_MCU_PROJECT_PATIENT_FAIL'

export const RESET_MCU_PROJECT_PATIENT_BATCH = 'RESET_MCU_PROJECT_PATIENT_BATCH'
